import type { ReactNode } from "react";
import { Flourish } from "../Ornaments";

type Props = {
  id: string;
  title: string;
  subtitle: string;
  icon?: ReactNode;
  variant?: "rules" | "flourish";
  italic?: boolean;
};

export function SectionHeading({
  id,
  title,
  subtitle,
  icon,
  variant = "flourish",
  italic = true,
}: Props) {
  return (
    <div className={`section-heading section-heading--${variant}`}>
      <div className="section-heading-row">
        {variant === "rules" ? (
          <span className="heading-rule" aria-hidden="true" />
        ) : (
          <Flourish className="heading-flourish" />
        )}
        <h2
          id={id}
          className={`section-title${italic ? " section-title--italic" : ""}`}
        >
          {icon}
          {title}
        </h2>
        {variant === "rules" ? (
          <span className="heading-rule" aria-hidden="true" />
        ) : (
          <Flourish className="heading-flourish heading-flourish--right" />
        )}
      </div>
      <p className="section-subtitle">{subtitle}</p>
    </div>
  );
}
